import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

// When the read more button is initially shown to the user
export const onReadMoreButtonShown: (props: commonAttributesType) => AnalyticsEventPayload = (
	props: commonAttributesType,
): AnalyticsEventPayload => {
	const { query, source } = props;
	return {
		action: 'shown',
		actionSubject: 'aiAnswerReadMoreButton',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
		},
		nonPrivacySafeAttributes: {
			query,
		},
	};
};
